export default {
    data() {
        return {
            newsFeeds: {},
            weatherData: null,
            weatherOptions: { unit: "f" },
            storyOrder: null,
            storyBlockList: [],
            activeStoryBlockList: [],
            activeBlockStart: 0,
            activeBlockAddSize: 3,
            activeBlockStoryCount: 7,
            feedCategories: [],
        };
    },
    methods: {
        getHeroStory() {
            const { newsFeeds } = this;
            if (newsFeeds && Object.keys(newsFeeds)) {
                this.storyOrder = this.shuffleArray(Object.keys(newsFeeds));
                if (this.storyOrder && this.storyOrder[0]) {
                    const chosenFeed = newsFeeds[this.storyOrder[0]];
                    if (chosenFeed && chosenFeed[0])
                        return {
                            story: chosenFeed[0],
                            category: this.storyOrder[0],
                        };
                }
            }
            return null;
        },
        async getWeatherFeed() {
            let url = "/api/news/v1/getFeeds?feeds=weather";
            if (this.weatherOptions.unit)
                url += `&weatherUnit=${this.weatherOptions.unit}`;
            if (this.weatherOptions.lat && this.weatherOptions.lon)
                url += `&weatherLat=${this.weatherOptions.lat}&weatherLon=${this.weatherOptions.lon}`;
            const req = await fetch(url);
            if (req.ok) {
                const res = await req.json();
                if (res && res[0] && res[0]) this.weatherData = res[0];
                else this.weatherData = null;
            } else this.weatherData = null;
        },
        async getNewsFeeds() {
            const getFeed = feedName =>
                new Promise(async (resolve, reject) => {
                    const req = await fetch(
                        `/y-feeds/news/v1/${feedName}?length=-1`
                    );
                    if (req.ok) {
                        const res = await req.json();
                        if (res) resolve(res);
                        else resolve(null);
                    } else resolve(null);
                }).catch(e => null);

            const newsFeedsList = [
                "topNews",
                "entertainment",
                "sports",
                "lifestyle",
                "finance",
                "shopping",
            ];
            const promiseList = [];
            for (const i in newsFeedsList)
                promiseList.push(getFeed(newsFeedsList[i]));

            const resNewsFeeds = await Promise.all(promiseList);
            for (const i in resNewsFeeds) {
                try {
                    const feed = resNewsFeeds[i][0];
                    if (feed.name && feed.data)
                        this.newsFeeds[feed.name] = feed.data;
                } catch (e) {}
            }
            if (this.newsFeeds)
                this.feedCategories = Object.keys(this.newsFeeds);
        },
        async getAllFeeds() {
            await Promise.all([this.getNewsFeeds(), this.getWeatherFeed()]);
        },
        shuffleArray(oldArray) {
            const array = oldArray;
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        addToBlockList(shuffle = false) {
            const newsFeeds = this.filteredNewsFeeds;

            // Randomize story block order
            if (newsFeeds && Object.keys(newsFeeds)) {
                this.storyOrder = this.shuffleArray(Object.keys(newsFeeds));
            }

            if (shuffle) {
                for (let i = 0; i < this.storyOrder.length; i++) {
                    newsFeeds[this.storyOrder[i]] = this.shuffleArray(
                        newsFeeds[this.storyOrder[i]]
                    );
                }
            }

            const listSize = this.activeBlockStoryCount;
            let currentStartIndex = 0;

            let checkDone = this.storyOrder.length;

            while (checkDone > 0) {
                for (let i = 0; i < this.storyOrder.length; i++) {
                    if (
                        currentStartIndex + listSize <
                        newsFeeds[this.storyOrder[i]].length
                    ) {
                        const tempArray = newsFeeds[this.storyOrder[i]];
                        this.storyBlockList.push({
                            name: this.titleCase(this.storyOrder[i]),
                            storyList: tempArray.slice(
                                currentStartIndex,
                                currentStartIndex + listSize
                            ),
                        });
                    } else checkDone--;
                }
                currentStartIndex += listSize;
            }
        },
        titleCase(str) {
            str = str.toLowerCase().split(" ");
            for (let i = 0; i < str.length; i++) {
                str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
            }
            return str.join(" ");
        },
        sendMessageToExt(msgToPost) {
            return new Promise((resolve, reject) => {
                var receiveMessage = function(e) {
                    if (e.data && e.data.msg == "msgResponse") {
                        window.removeEventListener(
                            "message",
                            receiveMessage,
                            false
                        );
                        resolve(e.data.res);
                    }
                };
                window.addEventListener("message", receiveMessage, false);
                window.parent.postMessage(msgToPost, "*");
                setTimeout(() => {
                    reject(new Error("message timed out"));
                }, 500);
            });
        },
    },
};
